@if (userFeedback) {
    <mat-card appearance="outlined">
        <mat-card-content>
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-justify-between tw-items-center">
                    <div
                        class="tw-justify-between tw-text-xl tw-flex-col tw-flex tw-w-3/4 tw-mr-2 tw-truncate"
                    >
                        <mat-label>
                            {{
                                userFeedback?.ticketNum
                                    ? "#" + userFeedback.ticketNum
                                    : "Ticket Number Missing"
                            }}
                        </mat-label>
                    </div>
                    <mat-chip
                        [ngClass]="{
                            'm3-success':
                                userFeedback.status === Status.Processed,
                            'm3-caution':
                                userFeedback.status === Status.Updated,
                            'm3-primary': userFeedback.status === Status.New
                        }"
                        highlighted
                        class="tw-ml-auto"
                    >
                        <div class="tw-min-w-20 tw-text-center">
                            {{ getStatus() }}
                        </div>
                    </mat-chip>
                </div>

                <div class="tw-flex">
                    <div class="tw-truncate">
                        - {{ userFeedback.submittedByName ?? "Unknown User" }}
                    </div>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-1">
                    <div class="tw-m-3 tw-text-base tw-flex tw-flex-col">
                        <div
                            class="tw-font-medium tw-truncate"
                            [innerHTML]="
                                userFeedback.description ??
                                'No Ticket Description Provided'
                            "
                        ></div>
                        <div
                            class="tw-m-3 tw-mb-0 tw-text-base tw-overflow-y-auto tw-h-[175px]"
                            [innerHTML]="
                                userFeedback.details ??
                                'No Ticket Body Provided'
                            "
                        ></div>
                    </div>

                    <div class="tw-mt-auto tw-m-3">
                        <button
                            mat-raised-button
                            class="tw-text-l"
                            (click)="seeDetails()"
                        >
                            <mat-icon>open_in_new</mat-icon>
                            See Details
                        </button>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
}
